<template>
  <section class="section section-shaped section-lg my-0">
    <div class="shape shape-style-1 bg-gradient-default">
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
    </div>
    <div class="container pt-lg-md">
      <div class="row justify-content-center">
        <div class="col-lg-5">
          <card type="secondary" shadow
                header-classes="bg-white pb-5"
                body-classes="px-lg-5 py-lg-5"
                class="border-0">
            <template>
              <div v-if="login_errado" class="alert alert-danger" role="alert">
                Número de inscrição ou CPF inválido.
              </div>
              <div class="text-muted text-center mb-3">
                <small>Entre com:</small>
              </div>
              <div class="btn-wrapper text-center">
              </div>
            </template>
            <template>
              <form @submit.prevent="envia_login" role="form">
                <base-input v-model="username" alternative
                            class="mb-3"
                            v-mask="'#######-#'"
                            placeholder="Número de inscrição"
                            addon-left-icon="ni ni-single-02">
                </base-input>
                <base-input v-mask="'###.###.###-##'" v-model="password" alternative

                            placeholder="CPF"
                            addon-left-icon="ni ni-badge">
                </base-input>

                <div class="text-center">
                  <base-button native-type="submit" type="primary" class="my-4">Entrar</base-button>
                </div>
              </form>
            </template>
          </card>
          <div class="row mt-3">
            <div class="col-6">
              <a href="#" class="text-light">
                <!--                <small>Esqueci minha senha</small>-->
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import axios from 'axios';
import {useRouter} from 'vue-router';
import Vue from 'vue'
import vueCrypt from 'vue-crypt'
import {cpf} from "cpf-cnpj-validator";

export default {
  name: 'Login',
  data() {
    return {
      username: '',
      password: '',
      login_errado: false,
      logins: [{cpf: 321., num_cand: 123}]
    }
  },
  methods: {
    envia_login: async function () {

      const encryptedText = this.CryptoJS.AES.encrypt("Hi There!", 'secret key 123').toString()
      const decryptedText = this.CryptoJS.AES.decrypt('U2FsdGVkX1+rGzJrqd1xvB4s0Sxxmcl9dbo4sUwcMsE=', 'secret key 123').toString(this.CryptoJS.enc.Utf8)

      const encrypt = (texto) => {
        return this.CryptoJS.AES.encrypt(texto, 'yqKdRqWEAywufSJCZpvPUF5e929UKqMh5eh7AMP5Xpv2FrmdpFeSsnVkyTGvrhPRUG48tZtn32sEGz2R8tDrGcR6wTyYwhdCEvZxbdW42SYpKF7HvrW2XK6zjuWX9946tTx5RhycNDEW8uS475mRVNASZ4CW4v4RhBS5SYHCNHc6DjpwpzWcwuMvTQzCBzMtGbXF8ud4qXhcXnwAQ3xef2tQz3ZeBjvhu32zNGY5PXem92HX3MLRhuw78TqUVsUT').toString()
      }
      const decrypt = (texto) => {
        return this.CryptoJS.AES.decrypt(texto, 'yqKdRqWEAywufSJCZpvPUF5e929UKqMh5eh7AMP5Xpv2FrmdpFeSsnVkyTGvrhPRUG48tZtn32sEGz2R8tDrGcR6wTyYwhdCEvZxbdW42SYpKF7HvrW2XK6zjuWX9946tTx5RhycNDEW8uS475mRVNASZ4CW4v4RhBS5SYHCNHc6DjpwpzWcwuMvTQzCBzMtGbXF8ud4qXhcXnwAQ3xef2tQz3ZeBjvhu32zNGY5PXem92HX3MLRhuw78TqUVsUT').toString(this.CryptoJS.enc.Utf8);
      }

      const gera_file_name = (cpf, num_cand) => {

        let candidato = {CPF: cpf, NUMEROINSC: num_cand}
        let cod_projeto = '2106_pt'
        let codigo_meio = candidato.CPF.replace(/\./g, '').replace('-', '') * 7919;
        codigo_meio = codigo_meio.toString()

        let codigo_arquivo = parseInt(codigo_meio.substring(0, 5)) * parseInt(candidato.NUMEROINSC.replace('-', '')) * 13 + '_'
            + String.fromCharCode(65 + parseInt(codigo_meio[3]))
            + String.fromCharCode(parseInt(codigo_meio[1] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[1]))
            + String.fromCharCode(parseInt(codigo_meio[4] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[5]))
            + String.fromCharCode(parseInt(codigo_meio[3] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[2]))
            + String.fromCharCode(parseInt(codigo_meio[7] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[7]))
            + '-'
            + String.fromCharCode(parseInt(codigo_meio[0] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[11]))
            + String.fromCharCode(parseInt(codigo_meio[1] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[9]))
            + String.fromCharCode(parseInt(codigo_meio[5] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[4]))
            + String.fromCharCode(parseInt(codigo_meio[8] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[5]))
            + String.fromCharCode(parseInt(codigo_meio[3] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[8]))
            + '_'
            + String.fromCharCode(parseInt(codigo_meio[2] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[3]))
            + String.fromCharCode(parseInt(codigo_meio[8] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[4]))
            + String.fromCharCode(parseInt(codigo_meio[3] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[6]))
            + String.fromCharCode(parseInt(codigo_meio[6] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[2]))
            + String.fromCharCode(parseInt(codigo_meio[3] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[11]))
            + String.fromCharCode(parseInt(codigo_meio[8] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[9]))

        return codigo_arquivo + '.pdf';
      }


      let cands =
          [{"num_cand":"U2FsdGVkX198hsP7KYUwI0JaZ3bzHuHulLq9zpFQ2uQ=","cpf":"U2FsdGVkX19/euNs+bprdO5cDSoHCAmrsjwXuq5DOY4="},{"num_cand":"U2FsdGVkX1+0kVDW8wBWQSrhjl25PJX6IXS/2ibfpnU=","cpf":"U2FsdGVkX1/7xOm618kIU5fCNOk5S4OFVpIitQlHFlU="},{"num_cand":"U2FsdGVkX189slgPWPZk3158CDa43LFAfh9DmGi5kOk=","cpf":"U2FsdGVkX196GHCS7v6xwsFfNwIH9USje3+MbkJz9cg="},{"num_cand":"U2FsdGVkX1/0+1dhJwx84hE+cvlvuzgMwjEOGW0embE=","cpf":"U2FsdGVkX1+9YWHjsrqmcTZg2zqc/GYmWuMojj7CUJk="},{"num_cand":"U2FsdGVkX18jQsBxvR0cXgVanI3A3g6LzyNVvZV4Cxo=","cpf":"U2FsdGVkX1/g18NuKAxhRrq5u8RfNjIFbLjDoHEmWdI="},{"num_cand":"U2FsdGVkX18ilcw8U7HLq2703QYEBPhjoBLyzrLEZew=","cpf":"U2FsdGVkX1+0+U7VvHlgiNUlTjlPAfYcXQKL1V2r+CM="},{"num_cand":"U2FsdGVkX18m1QnoGQ9VZOL4oIM8iweT+ZYb+hcXElU=","cpf":"U2FsdGVkX1+dzUm/chPNVi5yvYnP8PLYkEXxUcUqUWc="},{"num_cand":"U2FsdGVkX1+j7iNWbHviXvixhefMATAlx828eR6gX/E=","cpf":"U2FsdGVkX1+cKaiq2fBbQDrz1hFwy5ppg3MoZER0WYU="},{"num_cand":"U2FsdGVkX18e+waa2/ESKIfhwZGis2hmGa7WggIvViM=","cpf":"U2FsdGVkX190g/h+amvSz77DmhZIftJ6kkMwvV0H4BY="},{"num_cand":"U2FsdGVkX1/kREFOA9eNEuDjQ5ILrxXfM+4q2ay5Z6E=","cpf":"U2FsdGVkX18zLp1Sbqoa67HON2kyNFoJBnpJ+w7DZVg="},{"num_cand":"U2FsdGVkX1+y0I48mogMqBSvzYNaXHekuRxzwFTB0hY=","cpf":"U2FsdGVkX1/4AoSSbNWxQ+V6QI0pyUSJGL6PljfLesI="},{"num_cand":"U2FsdGVkX19Q1gXpe68jMmERg485s9md06Hn6AhcJDQ=","cpf":"U2FsdGVkX1+lmLvC6AxBwPO0s4yGGh1gSpA/hHflI7E="},{"num_cand":"U2FsdGVkX1/nkldNX/iaVwgpFLiJ0QtaHmM/Foz5rHA=","cpf":"U2FsdGVkX1+2Gn+BDAEIGLPAxBTKOHJPu6zM81MfUc8="},{"num_cand":"U2FsdGVkX1+NsRIHsWYVWKbKPu5uk+H5k00shspjjX4=","cpf":"U2FsdGVkX1+3yLTeW69AuYeAyGltyQRJ3Qy+0O2QtFA="},{"num_cand":"U2FsdGVkX19B1PSANR0tMCb50HxABtX+rwx0ED7Yb44=","cpf":"U2FsdGVkX18PkJJYo8uBKMuREMf4Vr2ZOudPrKoRtP8="},{"num_cand":"U2FsdGVkX19KqV2vJICr9ISd31iqJFcjKVWO/3dgcL4=","cpf":"U2FsdGVkX1+brYhBcz3M2UoFh+LmMJlUvhgNqj/ds+s="},{"num_cand":"U2FsdGVkX1+skHoJCkTs4vBhO9dOwY1/uyYFFwImwQ4=","cpf":"U2FsdGVkX19ohfim+eswX7VtbDfAUpTviU/GLe3bO04="},{"num_cand":"U2FsdGVkX184xLNO1JidiM3kL7D8NcrEhdJVzHCYYIg=","cpf":"U2FsdGVkX19obPYfClXv6jHzPGKJId7RVYLKo/YD1oE="},{"num_cand":"U2FsdGVkX19WfThzlDnGnbUaZ6FlEk4QHOlA0hxePLI=","cpf":"U2FsdGVkX18/415nd7eQgCdFPwh+r671LXmBWKTyw6c="},{"num_cand":"U2FsdGVkX1+jT30t0Ni5JLk3r3coVN05zUKax4/5t/Y=","cpf":"U2FsdGVkX18nFJRJHb5R5IykO/Gc6qpI/cy5B5CNH+E="},{"num_cand":"U2FsdGVkX18Sh3CV2TqNNuejip4AW007+U83mTm2gR0=","cpf":"U2FsdGVkX18aKMuIdwt1leNn8079xzuyw/af1jW1axw="},{"num_cand":"U2FsdGVkX1/Ke0hlypaPkYaaofjGcpLpNqdHxrDo++k=","cpf":"U2FsdGVkX18ak4jCrEV7cizAWzh36vb2XDXtjZK1TkU="},{"num_cand":"U2FsdGVkX1/m148+mWAm5ZgPs3DF3h9sW9g0a59O2q0=","cpf":"U2FsdGVkX19T3/SWOrzBtfMfV4ME8FZk8GwV81eTigg="},{"num_cand":"U2FsdGVkX18Ahx+WbdcxXk0vE0lCIUH9FIuxe06O/Og=","cpf":"U2FsdGVkX1+7dq5bVV8hspM/mItwjwp/mwkBbE3dTDU="},{"num_cand":"U2FsdGVkX19M2F5G5MxO192sbW3intXKWIayFlb0I2E=","cpf":"U2FsdGVkX18dcaZ0qwB9OYV/0iAwh4kggl2qE0TC5pY="},{"num_cand":"U2FsdGVkX1/InN9f3903fzoQ4NCFauV4f8+G4S5D0QA=","cpf":"U2FsdGVkX19wGSsLBerAZoCAj1vnUKTbQMeBOdbJLxw="},{"num_cand":"U2FsdGVkX18QjIs0rlnHME8SKwtJuftJlgbLhb1kVLo=","cpf":"U2FsdGVkX1/fH5K30gwS6p6LufRb4foEOdxbjKDbDz4="}]


      try {
        let concurso = this.$route.params.concurso;
        localStorage.setItem('concurso', concurso);

        for (let login of cands) {
          let num_cand_decripted = decrypt(login.num_cand);
          let cpf_decripted = decrypt(login.cpf);

          // console.log(num_cand_decripted,cpf_decripted)
          if (num_cand_decripted == this.username && cpf_decripted == this.password) {
            console.log(`Logged`)
            let nome_arquivo = (gera_file_name(cpf_decripted, num_cand_decripted))
            nome_arquivo = nome_arquivo.replace(/\x00/g, '-');


            // alert(`Logou`);
            let url = (`https://fs.ibfc.org.br/arquivos/2211/rec_insc/${nome_arquivo}`)
            return window.location = url;
          }
        }

        throw new Error(`Login inválido`);


      } catch (error) {
        console.log(error);
        this.login_errado = true;
      }
    }
  }
};
</script>
<style>
</style>
